import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme/scalingTokens';

export const useEventCardStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    backgroundColor: tokens.colorNeutralBackground1,
    boxShadow: tokens.shadow2,
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
    marginBottom: tokens.spacingVerticalXS,
  },
  timeColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '100px',
    marginRight: tokens.spacingHorizontalM,
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground2,
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalM),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    textAlign: 'center' as const,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: tokens.spacingVerticalXS,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  title: {
    fontSize: fontScale.subtitle,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  metadataRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground3,
  },
  roomName: {
    fontWeight: tokens.fontWeightSemibold,
  },
  separator: {
    color: tokens.colorNeutralStroke2,
  },
  roomTypeBadge: {
    ...shorthands.padding('2px', tokens.spacingHorizontalS),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightSemibold,
    backgroundColor: tokens.colorNeutralBackground3,
    marginLeft: 'auto',
    whiteSpace: 'nowrap',
  },
  largeBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    ...shorthands.padding('2px', tokens.spacingHorizontalS),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    fontSize: fontScale.caption,
    fontWeight: tokens.fontWeightBold,
    backgroundColor: tokens.colorPaletteRedBackground2,
    color: tokens.colorPaletteRedForeground1,
  },
  rootResponsive: {
    '@media (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  timeColumnResponsive: {
    '@media (max-width: 768px)': {
      marginRight: 0,
      marginBottom: tokens.spacingVerticalXS,
    },
  },
});
